import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDataSourceTemplateForEditFormDocument,
  type GetDataSourceTemplateForEditFormQuery,
  type GetDataSourceTemplateForEditFormQueryVariables,
} from "~/features/dataSourceTemplates/gqls";
import { useTenant } from "~/features/tenant/context";

export function useDataSourceTemplateForEditForm(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  return useSuspenseQuery<GetDataSourceTemplateForEditFormQuery, GetDataSourceTemplateForEditFormQueryVariables>(
    GetDataSourceTemplateForEditFormDocument,
    { variables: { tenantId, id } },
  );
}
